import {Injectable} from "@angular/core";
import {Environment} from "../configuration/environment";

@Injectable()
export class ConfigurationService {

  env:Environment;
  baseUrl:string;
  familiesUrl:string;
  familiesPublicUrl:string;
  familiesBusinessUrl: string;
  stripeAPIKey: string;

  deepLinkUrl: string;

  constructor() {
    this.env = Environment.Prod;
    this.setUrl();
  }

  private setUrl():void {
    if (ENV == 'local') {
      this.env = Environment.Local;
      this.baseUrl = 'http://localhost:8081/api';
      this.familiesUrl = 'http://localhost:8080';
      this.familiesPublicUrl = 'http://localhost:8080';
      this.familiesBusinessUrl = 'http://localhost:8082';
      this.stripeAPIKey = 'pk_test_6rSyQw52YLMlz3DaMODUQJ5b';
    }

    if (ENV == 'development') {
      this.env = Environment.Dev;
      this.baseUrl = 'https://api-dev.families.fr/api';
      this.familiesUrl = 'https://dev.families.fr';
      this.familiesPublicUrl = 'https://dev.families.fr';
      this.familiesBusinessUrl = 'https://business-dev.families.fr';
      this.stripeAPIKey = 'pk_test_6rSyQw52YLMlz3DaMODUQJ5b';
    }

    if (ENV == 'production') {
      this.env = Environment.Prod;
      this.baseUrl = 'https://api.families.fr/api';
      this.familiesUrl = 'https://www.families.fr';
      this.familiesPublicUrl = 'https://www.families.fr';
      this.familiesBusinessUrl = 'https://business.families.fr';
      this.stripeAPIKey = 'pk_live_J0hPj7zP3ce4EM0hBIBBqD7B';
    }

    this.deepLinkUrl = 'https://families.app.link/redirect';
  }

  getBaseUrl():string {
    return this.baseUrl;
  }

  getEnvironmentAsString(): string {

    if (this.env == Environment.Local) {
      return 'local';
    }

    if (this.env == Environment.Dev) {
      return 'dev';
    }

    if (this.env == Environment.Prod) {
      return 'prod';
    }

  }

  getFamiliesUrl() {
    return this.familiesUrl;
  }

  getFamiliesPublicUrl() {
    return this.familiesPublicUrl;
  }

  getBusinessUrl() {
    return this.familiesBusinessUrl;
  }

  getDeepLinkUrl() {
    return this.deepLinkUrl;
  }

  getStripeAPIKey() {
    return this.stripeAPIKey;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/configuration.service.ts